import { render, staticRenderFns } from "./OpenedOrders.vue?vue&type=template&id=527f05c9&"
import script from "./OpenedOrders.vue?vue&type=script&lang=js&"
export * from "./OpenedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports